module.exports = __webpack_public_path__ + "fc75dd05f51946dcfa1028f52b5e97cb.png";